import React from 'react';
import { TectuLogo } from './TectuLogo';
import { DOCUMENT_TITLE } from '../../index';
import NewLogo from 'assets/svg/NewLogo';

export const Logo = (props) => {
  const LogoComponent = DOCUMENT_TITLE === 'Tectu' ? TectuLogo : NewLogo;
  return <LogoComponent {...props} />;
};
